<div class="region-select-wrapper">
  <label class="form-label">{{ 'Region' | translate }}</label>
  <div class="select-trigger" (click)="toggleDropdown()" [class.active]="isOpen">
    @if (selectedRegionId) {
    <span class="selected-value">
      {{ getRegionById(selectedRegionId) | serverTranslate:'names' }}
    </span>
    <span class="clear-icon" (click)="clearSelection($event)">&times;</span>
    } @else {
    <span class="placeholder">{{ 'Select region' | translate }}</span>
    <i class="pi pi-chevron-down arrow-icon" [class.rotated]="isOpen"></i>
    }
  </div>
  @if (isOpen) {
  <div class="dropdown-panel">
    <div class="filter-container">
      <input type="text" class="filter-input" [(ngModel)]="filterText" (input)="onFilterChange()"
        [placeholder]="'Search...' | translate" (click)="$event.stopPropagation()" />
      <i class="pi pi-search filter-icon"></i>
    </div>
    <div class="tree-list">
      @for (parent of filteredTreeData; track parent.id) {
      <div class="tree-item parent-item">
        <div class="item-content" (click)="selectRegion(parent)" [class.selected]="parent.id === selectedRegionId">
          @if (parent.children?.length) {
          <span class="expand-icon" [class.rotated]="parent.isOpen" (click)="toggleParent(parent, $event)">
            <i class="pi pi-chevron-right" style="font-size: 10px;"></i>
          </span>
          } @else {
          <span class="expand-placeholder" style="width: 20px; display:inline-block;"></span>
          }
          <span class="item-name">{{ parent | serverTranslate:'names' }}</span>
        </div>
        @if (parent.isOpen && parent.children?.length) {
        <div class="children-container">
          @for (child of parent.children; track child.id) {
          <div class="tree-item child-item" [class.selected]="child.id === selectedRegionId"
            (click)="selectRegion(child)">
            <span class="item-name">{{ child | serverTranslate:'names' }}</span>
          </div>
          }
        </div>
        }
      </div>
      }
      @if (filteredTreeData.length === 0) {
      <div class="empty-state">{{ 'No regions found' | translate }}</div>
      }
    </div>
  </div>
  }
</div>
